import { render, staticRenderFns } from "./CreateAlertModal.vue?vue&type=template&id=cdecdcfc&scoped=true&"
import script from "./CreateAlertModal.vue?vue&type=script&lang=js&"
export * from "./CreateAlertModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdecdcfc",
  null
  
)

export default component.exports